export const ENTITIES_TYPE_REQUEST_WITH_SITE_ID = ["integrations"];
